/* Fishs Eddy — B2B FAQ topic navigation (progressive enhancement)
   The topic links are plain #anchors and work without this file.
   This adds: the current topic highlighted while scrolling (aria-current),
   the active chip kept in view on phones, smooth scrolling (unless the
   visitor prefers reduced motion), and focus moved to the topic heading
   after a jump so keyboard and screen-reader users land in the right place. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.getAttribute('data-fe-faq-ready')) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-fe-faq-group]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-fe-faq-link]'));
    if (!groups.length || !links.length) return;
    root.setAttribute('data-fe-faq-ready', 'true');

    var chips = root.querySelector('[data-fe-faq-chips]');
    var currentId = null;

    function keepChipInView(chip) {
      if (!chips || !chip || chips.offsetParent === null) return;
      var left = chip.offsetLeft;
      var right = left + chip.offsetWidth;
      if (left < chips.scrollLeft || right > chips.scrollLeft + chips.clientWidth) {
        var target = Math.max(0, left - 16);
        if (typeof chips.scrollTo === 'function') {
          chips.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          chips.scrollLeft = target;
        }
      }
    }

    function setActive(id) {
      if (id === currentId) return;
      currentId = id;
      links.forEach(function (a) {
        if (a.getAttribute('data-fe-faq-link') === id) {
          a.setAttribute('aria-current', 'location');
          if (chips && chips.contains(a)) keepChipInView(a);
        } else {
          a.removeAttribute('aria-current');
        }
      });
    }

    // A topic becomes "current" once its heading reaches the spot where a jump
    // lands it: the heading's own scroll-margin-top (sticky header + chip bar +
    // breathing room, set in the CSS), plus a few pixels of tolerance.
    function offsetLine() {
      var margin = parseFloat(getComputedStyle(groups[0]).scrollMarginTop) || 0;
      return margin + 8;
    }

    var ticking = false;
    function update() {
      ticking = false;
      var line = offsetLine();
      var active = groups[0].id;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].getBoundingClientRect().top - line <= 0) {
          active = groups[i].id;
        } else {
          break;
        }
      }
      setActive(active);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true },
    );
    window.addEventListener('resize', update);

    links.forEach(function (a) {
      a.addEventListener('click', function (event) {
        var target = document.getElementById(a.getAttribute('data-fe-faq-link'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          target.focus();
        }
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + target.id);
        }
        //Removing active since scrolling makes it active
        // setActive(target.id);
      });
    });

    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fe-faq]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
